'use strict';

module Patersons {

    export interface ETFCompareScope extends ng.IScope {
        events: Patersons.ETFCompareCtrl;
    }

    export class ETFCompareCtrl extends AnalysisBaseCtrl {
        scope: Patersons.ETFCompareScope;
        rootScope: any;
        static $inject = ['$scope', '$log', '$location', '$window', '$state', '$stateParams', '$http', '$rootScope', 'navigationService'];

        constructor($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, navigationService) {
            super($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, navigationService);
            this.scope = $scope;
            this.scope.events = this;
            this.state = $state;

            this.load();


        }
        load(){
            var isinData = this.state.params['secIds']
                ? this.state.params['secIds']
                : "";

            var self = this;

            rootMorningstarPromise().then(function (
                promiseChain
            ) {
                console.log("initializing component");
                    initComponent(
                        "component-investcomp",
                        "ecinvestment-container",
                        "ec-investment-compare",
                        "ecETFCompare"
                    ).then(function () {
                        morningstar.asterix.instanceRegistry
                            .get("ecETFCompare")
                            .setParameter("securityIds", isinData); // pipe separated list of IDs
                    });
            });
        }
    }
}
